import styled from '@emotion/styled'
import { themedValue } from 'component-library/__styling/themed-value'
import { breakWords } from 'component-library/__styling/style-mixins'
import { calcRem } from 'component-library/__styling/style-functions'
import { fonts } from 'component-library/__styling/settings'
import { Button } from 'component-library/buttons/Button/Button'

export const GiveConsentButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    paddingLeft: calcRem(theme.margins.md),
    paddingRight: calcRem(theme.margins.md),
}))

export const StyledParagraph = styled('p')(({ theme }) => ({
    ...breakWords,
    fontSize: calcRem(14),
    fontFamily: themedValue(theme, {
        thewest: fonts.thewest.serif,
        perthnow: fonts.perthnow.sansSerif,
        sevennews: fonts.sevennews.sansSerif,
    }),

    lineHeight: themedValue(theme, {
        thewest: 1.4,
        fallback: 1.5,
    }),

    ['&:first-of-type']: {
        marginTop: 0,
    },
}))

export const StyledFieldset = styled('fieldset')(({ theme }) => ({
    border: 0,
    padding: 0,
    margin: `0 0 ${calcRem(theme.margins.md)} 0`,
}))

export const StyledLegend = styled('legend')(({ theme }) => ({
    display: 'block',
    marginBottom: calcRem(theme.margins.md),
    fontWeight: 600,
}))

export const StyledLabel = styled('label')({
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',

    ['& + &']: {
        marginLeft: calcRem(21),
    },

    ['& > input']: {
        marginRight: calcRem(6),
    },
})

export const CheckMark = styled('div')(({ theme }) => ({
    backgroundColor: 'currentColor',
    width: 12,
    height: 3,
    marginLeft: themedValue(theme, {
        thewest: 14,
        perthnow: 12,
        sevennews: 14,
    }),
    transform: `rotate(-53deg) rotateY(180deg)`,

    ['&::before']: {
        content: '""',
        display: 'block',
        backgroundColor: 'inherit',
        width: 7,
        height: 3,
        transform: `rotate(90deg) translateY(-2px)`,
        transformOrigin: 'bottom right',
    },
}))
